<div class="row">
  <div class="stepper-wrapper col-12">
    <div class="stepper-item"
    [ngClass]="{'completed': isStepItemCompleted(step),'disabled': isStepItemDisabled(step),  'error': isStepItemError(step) , 'active' : isStepItemActive(step) }"
      *ngFor="let step of stepList; let i = index" (click)="changeStep(step.numeroStep, false, step)">
      <div class="step-counter"  >{{step.numeroStep}}</div>
      <h6 class="step-name hidden-xs">{{step.label | lowercase}}</h6>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <ng-template appInsertionHost></ng-template>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="row" >
    <p class="col-sm-3 col-xs-3 {{currentStepNumber === 1 ? 'pl-5' : ''}}">
      <button *ngIf="showElimina" type="button" class="btn btn-danger btn-block" (click)="deleteFascicoloTemp()" >Elimina bozza</button>
    </p>
    <p class="col-sm-3 col-xs-3">

    </p>
    <p *ngIf="!showSalvaAndEsci" class="col-sm-3 col-xs-3">

    </p>
    <p class="col-sm-3 col-xs-3">
      <button type='button' class='btn btn-primary btn-block' (click)="completa()" *ngIf="showCompleta">
        Completa
      </button>
    </p>
    <p *ngIf="showSalvaAndEsci" class="col-sm-3 col-xs-3 ">
      <button  type="button" class="btn btn-outline-secondary btn-block" (click)="exit()">Salva e esci</button>
    </p>
    <ng-container class="col-sm-3" *ngIf="!currentStep.customButtons && currentStepNumber != 8">
      <div class="row">

        <p class="col-sm-12 col-xs-12">
          <button type='button' class='btn btn-primary btn-block' (click)="salva()">
            {{buttonLabel}}
          </button>
        </p>
      </div>
    </ng-container>
    </div>
  </div>
</div>
